import React from "react";
import { useSelector } from "react-redux";
import ExportLoader from "./ExportLoader";

const GlobalExportLoader = () => {
    const { open, type, message } = useSelector((state) => state.export);
    return <ExportLoader type={type} open={open} message={message} />;
};

export default GlobalExportLoader;
